import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const VARIANTS = {
  lime: 'bg-lime text-charcoal hover:bg-lime-hover',
  dark: 'bg-charcoal text-offwhite hover:bg-charcoal-surface',
  'outline-dark': 'border border-charcoal/30 text-charcoal hover:border-charcoal hover:bg-charcoal hover:text-offwhite',
  'outline-light': 'border border-offwhite/40 text-offwhite hover:border-offwhite hover:bg-offwhite hover:text-charcoal',
};

export default function ArrowLink({ to, children, variant = 'lime', className = '', testid, onClick }) {
  return (
    <Link
      to={to}
      onClick={onClick}
      data-testid={testid}
      className={`group inline-flex items-center justify-center gap-2 rounded-full px-6 py-3 font-heading text-sm font-bold tracking-tight transition-[background-color,color,border-color,transform] duration-300 hover:-translate-y-0.5 ${VARIANTS[variant]} ${className}`}
    >
      {children}
      <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" aria-hidden="true" />
    </Link>
  );
}
